import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('ss_cookie_consent');
    if (consent === 'declined') {
      // Ensure GA stays blocked
      window['ga-disable-G-08NSSW3JLS'] = true;
    }
    if (!consent) {
      // First visit — show banner after short delay
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('ss_cookie_consent', 'accepted');
    setVisible(false);
    // Dynamically load GA now that user consented
    if (window._loadGA) {
      window._loadGA();
    }
  };

  const decline = () => {
    localStorage.setItem('ss_cookie_consent', 'declined');
    setVisible(false);
    // Block GA permanently for this session
    window['ga-disable-G-08NSSW3JLS'] = true;
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto bg-[#0F172A] border border-slate-700 rounded-2xl p-5 md:p-6 shadow-2xl flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex-1">
          <p className="text-white text-sm font-medium mb-1">We value your privacy</p>
          <p className="text-slate-400 text-xs leading-relaxed">
            This site uses cookies for Google Analytics to understand how visitors use our website. No personal data is sold.{' '}
            <Link to="/privacy" className="text-blue-400 underline">Privacy Policy</Link>
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="text-slate-400 hover:text-white text-sm font-medium transition-colors"
            data-testid="cookie-decline-btn"
          >
            Decline
          </button>
          <Button
            onClick={accept}
            className="bg-[#1E3A8A] hover:bg-[#1D4ED8] text-white font-bold text-sm px-5 py-2 rounded-full"
            data-testid="cookie-accept-btn"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
